import React, { useState, useMemo } from 'react';
import { Modal, Input, Tabs } from 'antd';
import { X, MagnifyingGlass } from '@phosphor-icons/react';
import DebtCard from '../Card/DebtCustomerCard';
// import { MOCK_DEBT } from 'constant/MockData';
import { formatPrice } from 'utils';
import { ButtonCommon } from '..';
import { Debt, DebtStatusCode } from 'models';

const QuickViewDebtModal: React.FC<{
  isOpen: boolean;
  onClick?: (id: string) => void;
  onClose: () => void;
  debts: Debt[];
}> = ({ isOpen, onClose, debts, onClick }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [activeTab, setActiveTab] = useState<string>('all');

  const { totalDebtAmount, filteredDebts } = useMemo(() => {
    // Filter by tab status first
    let debtsByStatus = debts;
    if (activeTab === 'all') {
      debtsByStatus = debts;
    } else if (activeTab === 'pending') {
      debtsByStatus = debts.filter((debt) => debt.status?.code === DebtStatusCode.WAITING);
    } else if (activeTab === 'completed') {
      debtsByStatus = debts.filter((debt) => debt.status?.code === DebtStatusCode.COMPLETED);
    }

    // Then filter by search query
    const filtered =
      searchQuery !== ''
        ? debtsByStatus.filter(
            (debt) =>
              debt.code?.toLowerCase().includes(searchQuery.trim().toLowerCase()) ||
              debt.name?.toLowerCase().includes(searchQuery.trim().toLowerCase()),
          )
        : debtsByStatus;

    const total = filtered.reduce((sum, debt) => sum + (debt.remainingAmount || 0), 0);

    return {
      totalDebtAmount: total,
      filteredDebts: filtered,
    };
  }, [searchQuery, debts, activeTab]);

  const tabItems = [
    {
      key: 'all',
      label: <span className='text-md font-medium'>Tất cả</span>,
    },
    {
      key: 'pending',
      label: <span className='text-md font-medium'>Đợi thu</span>,
    },
    {
      key: 'completed',
      label: <span className='text-md font-medium'>Hoàn tất</span>,
    },
  ];

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={1400}
      className='modal-none-padding'
      closeIcon={<X size={28} color='var(--textBlack)' />}
      maskClosable={false}
      centered
    >
      <div className='bg-white rounded-lg'>
        <div className='px-6 py-3'>
          <h2 className='text-[20px] leading-[24px] font-bold'>DANH SÁCH CÔNG NỢ</h2>
          <p className='text-[var(--textGray)] text-sm mt-2'>
            Tất cả công nợ của khách hàng mà bạn đang lên đơn đều được hiển thị tại đây
          </p>
        </div>

        <div className='bg-[var(--textBlack4)] p-4'>
          {/* Tabs Section */}
          <div className='mb-4'>
            <Tabs activeKey={activeTab} onChange={setActiveTab} items={tabItems} className='debt-modal-tabs' />
          </div>

          <div className='p-3 mb-6 justify-between  bg-white rounded-lg flex items-center  gap-6'>
            <div className=''>
              <div className='flex items-center gap-2'>
                <span className='text-black/60'>Số lượng công nợ:</span>
                <span className='font-bold'>{filteredDebts.length}</span>
                <span className='text-sm font-bold'>Đơn</span>
              </div>
            </div>
            <div className=''>
              <div className='flex items-center gap-2'>
                <span className='text-black/60 w-28'>Tổng công nợ:</span>
                <span className='font-bold text-rose-500'>{formatPrice(totalDebtAmount)}</span>
                <span className='text-sm font-bold text-rose-500'>VND</span>
              </div>
            </div>
            <div className='w-[50%]'>
              <Input
                placeholder='Tìm kiếm công nợ'
                suffix={<MagnifyingGlass size={16} />}
                className='h-12 px-4 py-3 bg-[var(--textBlack4)]  rounded-xl '
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
          </div>

          <div className='mt-2 overflow-hidden'>
            <div className='h-[50vh] overflow-y-auto flex flex-col gap-2'>
              {filteredDebts.length > 0 ? (
                filteredDebts.map((debt) => <DebtCard key={debt.id} debt={debt} onClick={onClick} />)
              ) : (
                <div className='p-6 text-center text-gray-500'>Không tìm thấy công nợ nào</div>
              )}
            </div>
          </div>
          <div className='flex justify-center items-center gap-4 mt-6 mb-2'>
            <ButtonCommon color='none' radius='rounded' onClick={onClose}>
              Thoát
            </ButtonCommon>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default QuickViewDebtModal;
